import Backbone from 'backbone';

module.exports = Backbone.Model.extend({
  defaults: {
    file_upload: '',
    array_file: [],
    numbel_img: 0
  },
  initialize(o) {}
});
